import React from 'react';
import PropTypes from 'prop-types';

import Menu from '../Menu';
import Dots from './Dots';
import Buttons from './Buttons';

const Hero = ({ title, children, button1, button2, isProduct }) => {
  return (
    <div className="relative overflow-hidden bg-indigo-700">
      <Dots />
      <div className="relative pt-6 pb-24 sm:pb-36">
        <Menu isProduct={isProduct} />
        <div className="max-w-screen-xl px-4 mx-auto mt-10 sm:mt-12 sm:px-6 md:mt-16 lg:mt-20 xl:mt-28">
          <div className="text-center">
            <h2 className="text-4xl tracking-tight leading-10 font-extrabold text-gray-200 sm:text-5xl sm:leading-none md:text-6xl">
              {title}
            </h2>
            <p className="mt-3 max-w-md mx-auto text-base text-gray-200 sm:text-lg md:mt-5 md:text-xl md:max-w-3xl">
              {children}
            </p>
            <Buttons button1={button1} button2={button2} />
          </div>
        </div>
      </div>
    </div>
  );
};

Hero.defaultProps = {
  isProduct: false,
  button1: null,
  button2: null,
};

Hero.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
  isProduct: PropTypes.bool,
  button1: PropTypes.shape({
    title: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
  button2: PropTypes.shape({
    title: PropTypes.string.isRequired,
    href: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
  }),
};

export default Hero;
